import KumovegaError from "./KumovegaError";

export default class ObjectNotFound extends KumovegaError {}
